const electronUserAgentRegex = /(Electron)\/([0-9]{1,}[.0-9]{0,})/;

const electronVersion = (userAgent) => {
  const matches = userAgent.match(electronUserAgentRegex);

  return matches && parseFloat(matches[2]);
};

export default electronVersion;
